
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accessDenied",
      function () {
        return require("private-next-pages/accessDenied/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accessDenied"])
      });
    }
  